<div class="app-nav-item" role="button" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (click)="initialClick(menuTrigger)" (mouseenter)="mouseEnter(menuTrigger, $event)" (mouseleave)="mouseLeave(menuTrigger, $event)">
  <ng-content select="[trigger]"></ng-content>
</div>
<mat-menu [class]="megaClass" #menu="matMenu" overlapTrigger="false" backdropClass="main-menu-backdrop" hasBackdrop="true" [aria-label]="itemName" aria-role="menu" >
  <div (mouseenter)="mouseEnter(menuTrigger, $event)" (mouseleave)="mouseLeave(menuTrigger, $event)">
    <ng-content select="[content]"></ng-content>
  </div>
</mat-menu>
